export const getPagination = (isSearch: boolean, page: number, pageFromStore: number) => {
  let resultPage = 1;

  if (isSearch && page === pageFromStore) resultPage = pageFromStore;

  else resultPage = page;

  return resultPage;
};
